import { render } from "./withdraw.vue?vue&type=template&id=5c644ea6&scoped=true"
import script from "./withdraw.vue?vue&type=script&lang=js"
export * from "./withdraw.vue?vue&type=script&lang=js"

import "./withdraw.vue?vue&type=style&index=0&id=5c644ea6&lang=scss&scoped=true"
import "./withdraw.vue?vue&type=style&index=1&id=5c644ea6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c644ea6"]])

export default __exports__